import { __extends } from "tslib";
import { GLESAssetBase } from './GLESAssetBase';
var IndexBufferGLES = /** @class */ (function (_super) {
    __extends(IndexBufferGLES, _super);
    function IndexBufferGLES(context, gl, numIndices, id) {
        var _this = _super.call(this, context, id) || this;
        _this._gl = gl;
        // this._buffer = this._gl.createBuffer();
        _this._numIndices = numIndices;
        return _this;
    }
    IndexBufferGLES.prototype.uploadFromArray = function (array, startOffset, count) {
        //GLESConnector.gles.uploadIndexDataFromArray(this.id, data, startOffset, count);
        // this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER, this._buffer);
        //
        // if (startOffset)
        // 	this._gl.bufferSubData(this._gl.ELEMENT_ARRAY_BUFFER, startOffset*2, new Uint16Array(data));
        // else
        // 	this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(data), this._gl.STATIC_DRAW);
    };
    IndexBufferGLES.prototype.uploadFromByteArray = function (data, startOffset, count) {
        //GLESConnector.gles.uploadIndexDataFromByteArray(this.id, data, startOffset, count);
        // this._gl.bindBuffer(this._gl.ELEMENT_ARRAY_BUFFER, this._buffer);
        //
        // if (startOffset)
        // 	this._gl.bufferSubData(this._gl.ELEMENT_ARRAY_BUFFER, startOffset*2, data);
        // else
        // 	this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, data, this._gl.STATIC_DRAW);
    };
    IndexBufferGLES.prototype.dispose = function () {
        //GLESConnector.gles.disposeIndexBuffer(this.id);
        // this._gl.deleteBuffer(this._buffer);
    };
    Object.defineProperty(IndexBufferGLES.prototype, "numIndices", {
        get: function () {
            return this._numIndices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexBufferGLES.prototype, "glBuffer", {
        get: function () {
            return this._buffer;
        },
        enumerable: false,
        configurable: true
    });
    return IndexBufferGLES;
}(GLESAssetBase));
export { IndexBufferGLES };
